const WHATSAPP_NUMBER = '+919594184195'; 

export const sendWhatsAppMessage = (formData) => {
  const message = `New Contact Form Submission:\n\n` +
    `Name: ${formData.name || 'N/A'}\n` +
    `Email: ${formData.email || 'N/A'}\n` +
    `Phone: ${formData.phone || 'N/A'}\n` +
    `Subject: ${formData.subject || 'N/A'}\n\n` +
    `Message:\n${formData.message || 'No message'}`;
  
  const cleanNumber = WHATSAPP_NUMBER.replace(/[^\d+]/g, '');
  const whatsappURL = `https://wa.me/${cleanNumber}?text=${encodeURIComponent(message)}`;
  window.open(whatsappURL, '_blank');
};

